const FormatVelocity = {
  'min/km': 'min/km',
  'km/h': 'km/h',
};

export { FormatVelocity };
